import React from 'react';
import createSvgIcon from '../../../shared/utils/create-svg-icon';
import { ReactComponent as Icon } from '../../../assets/icon-company.svg';

export const CompanyIcon = createSvgIcon(<Icon />, 'CompanyIcon');
